import { serverAddrToUploadMediaFiles, serverAddr } from "../networkConfig";
import CripNotice from "crip-vue-notice";
import moment from "moment";
import { EventBus } from "../eventBus";

export var derivativesApiCall = {
  methods: {
    getExperStrategytData(filter_obj) {
      this.isApiLoading = true
      EventBus.$emit("toggleButtonLoading", true);

      this.is_reco_list_loading = true;
      var url = "";
      var entries_count = null;
      if (this.$route.name == "PastStrategyOptions") {
        url = "/options/opinion/expert";
        entries_count = 5;
      } else if (this.$route.name == "ExpertsPastStrategyOptions" || this.$route.name == "optionsWatchlist") {
        url = "/options/opinion/market";
        entries_count =
          this.subscribedPlanDetails &&
            this.subscribedPlanDetails.plan == "Premium"
            ? 5
            : 2;
      }
      if (url) {
        serverAddr
          .post(url, {
            page_per_entries: entries_count,
            page_number: this.page_no,
            filters: filter_obj ? filter_obj.filters : [],
            expert_list: filter_obj ? filter_obj.expert_id_list : [],
            profession_list: filter_obj ? filter_obj.profession_list : [],
            company_list: filter_obj ? filter_obj.company_id_list : [],
            symbol: this.strikeSymbol,
            expiry: this.searchIndiceExpiry,
            indice: this.indiceName,
            strategy_id_list: this.selected_reco_id,
          })
          .then((response) => {
            if (response.data.status) {
              var other_expert_past_reco_list = response.data.data;
              this.is_reco_list_loading = false;

              // this loader is used for watchlist
              this.isApiLoading = false;
              EventBus.$emit("toggleButtonLoading", false);

              this.number_of_pages = response.data.pagination.total_pages;
              this.page_no = response.data.pagination.current_page;

              var end_date = new Date();
              other_expert_past_reco_list.forEach((element) => {
                // (target premium - LTP) * quantity *lot size

                element.totalRemainingPotential = 0;
                element.data.forEach((legValue) => {
                  var currentPrice = null;
                  if (legValue.status == "EXIT") {
                    currentPrice = legValue.status_action_price;
                  } else if (legValue.status == "TARGET_ACHIEVED") {
                    currentPrice = legValue.target_premium;
                  } else if (legValue.status == "STOPLOSS_TRIGGERED") {
                    currentPrice = legValue.stop_loss;
                  } else if (legValue.status == "YET_TO_LIVE") {
                    currentPrice = legValue.entry_premium;
                  } else {
                    currentPrice = legValue.stock.ltp;
                  }

                  if (legValue.direction == "BUY") {
                    // legValue.remainingPotentialInRupees = (legValue.target_premium - currentPrice) * legValue.quantity * legValue.stock.lot_size
                    legValue.remainingPotentialInRupees =
                      (legValue.target_premium - currentPrice) *
                      10 *
                      legValue.stock.lot_size;
                  } else if (legValue.direction == "SELL") {
                    // legValue.remainingPotentialInRupees = (currentPrice - legValue.target_premium) * legValue.quantity * legValue.stock.lot_size
                    legValue.remainingPotentialInRupees =
                      (currentPrice - legValue.target_premium) *
                      10 *
                      legValue.stock.lot_size;
                  }
                  element.totalRemainingPotential =
                    element.totalRemainingPotential +
                    legValue.remainingPotentialInRupees;

                  legValue.lot_quantity = 1;
                  legValue.exp_tax =
                    legValue.brokerage_data.total_tax_and_charges;
                  legValue.brokerage_loader = false;
                  legValue.strategy_id = element.strategy.id;
                });
                var titleExpiry = element.strategy.title.split(" ");
                element.strategy.title = titleExpiry[0];
                element.strategy.expiry = titleExpiry[1];

                element.strategy.difference_in_days = this.getDifferenceBetweenTwoDays(
                  element.strategy.created_date,
                  end_date
                );
                element.strategy.today = end_date;
                element.is_strategy_loading = false;
                element.toggle_more_info = false;
                // element.mediaArray = 

                // if (element.logic[0]) {
                //   var mediaArray = [];
                //   if (element.logic[0].media_1) {
                //     mediaArray.push(element.logic[0].media_1);
                //   }
                //   if (element.logic[0].media_2) {
                //     mediaArray.push(element.logic[0].media_2);
                //   }
                //   if (element.logic[0].media_3) {
                //     mediaArray.push(element.logic[0].media_3);
                //   }
                //   if (element.logic[0].media_4) {
                //     mediaArray.push(element.logic[0].media_4);
                //   }

                //   element.logic[0].mediaArray = mediaArray;
                // }
                this.other_expert_past_reco_list.push(element);
              });
            } else {
              this.is_reco_list_loading = false;

              // this loader is used for watchlist
              this.isApiLoading = false;
              EventBus.$emit("toggleButtonLoading", false);
            }
          })
          .catch((error) => {
            console.log(error);
            this.is_reco_list_loading = false;

            // this loader is used for watchlist
            this.isApiLoading = false;
            EventBus.$emit("toggleButtonLoading", false);
          });
      }
    },

    exitRecoCallBack(id, index) {
      this.recommendationsList[index].is_strategy_loading = true;
      serverAddr
        .patch(`/options/exit/strategy/${id}`)
        .then((response) => {
          if (response.data.status) {
            this.recommendationsList[index] = response.data.data;

            var titleExpiry = this.recommendationsList[
              index
            ].strategy.title.split(" ");
            this.recommendationsList[index].strategy.title = titleExpiry[0];
            this.recommendationsList[index].strategy.expiry = titleExpiry[1];
            this.recommendationsList[index].toggle_more_info = false;
            this.recommendationsList[index].is_strategy_loading = false;

            this.recommendationsList = JSON.parse(
              JSON.stringify(this.recommendationsList)
            );
            new CripNotice({
              title: "Success",
              description: response.data.validation,
              type: "success",
              duration: 3,
            });
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_reco_list_loading = false;
          // this.is_scroll_disabled = false;
        });
    },

    getStrikeDataCalBack() {
      this.strikeLoading = true;
      serverAddr
        .get(
          `/options/scrips?title=${this.selectedStock.title}&expiry=${this.selectedStock.expiry
          }&page_per_entries=${2000}&page_number=${1}`
        )
        .then((response) => {
          this.strikeData = [];
          if (response.data.status) {
            var strikeData = response.data.data;
            strikeData.forEach((element) => {
              var obj = {
                id: element.id,
                label: element.strike + element.instrument_type,
                strikePrice: element.strike,
                ltp: element.ltp,
                timeStamp: element.last_traded_timestamp,
                lot_size: element.lot_size,
                expiry: element.expiry,
                symbol: element.symbol,
              };

              this.strikeData.push(obj);
            });
          } else {
            // this.isOpen = false;                            //closed searched stock result list
            this.strikeData = [];
          }
          this.strikeLoading = false;
        })
        .catch(
          function (error) {
            this.strikeLoading = false;
            console.log("error");
          }.bind(this)
        );
    },

    calulateMarginCallBack(obj, index, lotSize) {
      serverAddr
        .post(`/options/calculate_margin`, obj)
        .then((response) => {
          if (response.data.status) {
            this.stockList[index].margin = response.data.required_margin
              ? response.data.required_margin
              : Number(obj.quantity) *
              Number(lotSize) *
              Number(obj.entry_premium);
          } else {
            this.stockList[index].margin =
              Number(obj.quantity) *
              Number(lotSize) *
              Number(obj.entry_premium);
            // this.isOpen = false;                            //closed searched stock result list
          }
          this.calculateTotalMargin();
        })
        .catch(function (error) {
          console.log("error");
        });
    },
    checkStrategyStatus(index, id, direction, date) {
      serverAddr
        .get(
          `/options/is_strategy_exists?stock=${id}&direction=${direction}&result_timestamp=${moment(
            date
          ).format("YYYY-MM-DD")}`
        )
        .then((response) => {
          if (response.data.status) {
            // if (response.data.data) {
            this.$alert(
              `Strategy Exist, Please update or try Different`,
              "Error!",
              {
                confirmButtonText: "OK",
              }
            );
            this.stockList[index].strike = "";
            this.stockList[index].direction = "";
            this.stockList[index].targetPeriod = "";
            // }
          }
        })
        .catch(function (error) {
          console.log("error");
        });
    },

    publishFinalData(list) {
      serverAddr
        .post("/options/publish", list)
        .then((response) => {
          if (response.data.status) {
            new CripNotice({
              title: "Recommendation published",
              description: response.data.validation,
              type: "success",
              duration: 3,
            });
            this.published_notification_dialog_visibility = true;

            if (response.data.data.strategy) {
              this.sendLogicToServer(
                response.data.data.strategy.id,
                this.editStrategyData.logic_id
              );
            }
          } else {
            new CripNotice({
              title: "Oops! Something went wrong!",
              description: response.data.validation,
              type: "error",
              duration: 3,
            });
          }
          this.is_sock_data_loading = false;
        })
        .catch((err) => {
          this.is_sock_data_loading = false;
          console.log(err);
          new CripNotice({
            title: "Oops! Something went wrong!",
            description: err.response.data.validation,
            type: "error",
            duration: 3,
          });
        });
    },
    editStrategyCallBack(list, strategy_id, logic_id) {
      serverAddr
        .patch(`/options/edit/strategy/${strategy_id}`, list)
        .then((response) => {
          if (response.data.status) {
            new CripNotice({
              title: "Recommendation published",
              description: response.data.validation,
              type: "success",
              duration: 3,
            });
            this.published_notification_dialog_visibility = true;
            if (this.isLogicValuesChange) {
              this.sendLogicToServer(strategy_id, logic_id);
            }
          } else {
            new CripNotice({
              title: "Oops! Something went wrong!",
              description: data.validation,
              type: "error",
              duration: 3,
            });
          }
          this.is_sock_data_loading = false;
        })
        .catch((err) => {
          this.is_sock_data_loading = false;
          console.log(err, "error");
          new CripNotice({
            title: "Error",
            description: "Oops! Something went wrong! Try again later",
            type: "error",
            duration: 3,
          });
        });
    },
    saveStrategyOverview(strategy_id) {
      var strategyData = {
        strategy_id: strategy_id,
        graph_data: this.strategyOverviewData,
      };
      serverAddr
        .post("/options/save_strategy_graph_data", strategyData)
        .then((response) => {
          return response;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    sendLogicToServer(strategy_id, logic_id) {
      this.saveStrategyOverview(strategy_id);
      if (this.logicDescription.length || this.logicFiles.length) {
        let formData = new FormData();

        if (this.logicFiles.length) {


          for (var i = 0; i < this.logicFiles.length; i++) {
            let item = this.logicFiles[i];

            // Check if it's a File object
            if (item instanceof File) {
              formData.append(`media_${i + 1}`, item);
            }
          }

          // formData.append("attachments", this.attachment);
        }
        if (logic_id) {
          formData.append("fno_logic_id", logic_id);
        }
        formData.append("description", this.logicDescription);
        formData.append("id", strategy_id);
        // formData.append("sub_tags", this.selectedTags);

        serverAddrToUploadMediaFiles
          .post("/options/fno_logic", formData)
          .then((response) => {
            return response;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    deleteStrategyLeg(strategy_leg_id, index) {
      this.is_sock_data_loading = true;
      // this.recommendationsList[index].is_strategy_loading = true;
      serverAddr
        .delete(`/options/delete/leg/${strategy_leg_id}`)
        .then((response) => {
          if (response.data.status) {
            this.stockList.splice(index, 1);
            new CripNotice({
              title: "Success",
              description: "Leg deleted successfully",
              type: "success",
              duration: 3,
            });
            this.is_sock_data_loading = false;
            // this.recommendationsList[index] = response.data.data

            // var titleExpiry = this.recommendationsList[index].strategy.title.split(' ')
            // this.recommendationsList[index].strategy.title = titleExpiry[0];
            // this.recommendationsList[index].strategy.expiry = titleExpiry[1];
            // this.recommendationsList[index].toggle_more_info = true;
            // this.recommendationsList[index].is_strategy_loading = false;

            // this.recommendationsList = JSON.parse(
            //     JSON.stringify(this.recommendationsList)
            // );
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDifferenceBetweenTwoDays(created_date, current_date) {
      //set time to 12:00 Am to because getting time in created date and current date
      //that returns if recommnedation created on 3PM then on second date when it's 3PM then it returns 1 day
      var createdDate = new Date(created_date).setHours(0, 0, 0, 0);
      var currentDate = new Date(current_date).setHours(0, 0, 0, 0);

      const diffTime = Math.abs(currentDate - createdDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      //if created date and current date is same then return 0
      if (
        new Date(createdDate).toLocaleDateString() ==
        new Date(currentDate).toLocaleDateString()
      ) {
        return 0;
      } else {
        return diffDays;
      }
    },
  },
};
